import React from 'react'

import axios from 'axios'
import Config from '../../Helpers/Config';
import {NotificationManager} from '../../Helpers/NotificationManager';;
import {locale} from '../../locale/AppLocale'
import Loader from '../../Components/Loader'
import {Link} from 'react-router-dom'

import {connect} from 'react-redux'

class Listing extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            data: [],
            loading:true
        }
    }

    render() {
        return (
            <div className="container">
                <table className="table ">
                    <thead>
                    <tr>
                        <th>{locale.get('file_name')}</th>
                        <th>{locale.get('status')}</th>
                        <th>{locale.get('upload_date')}</th>
                        <th>{locale.get('file_type')}</th>
                        {
                            this.state.data.length > 0 &&
                            <th></th>
                        }

                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.data.length > 0 &&
                        this.state.data.map((record, index) => (
                            <tr key={record.id}>

                                <th>{record.title}</th>
                                <th>{record.status}</th>
                                <th>{record.created_at}</th>
                                <th>{record.type}</th>
                                <th>
                                    {
                                        record.status_id === 3 &&

                                        <Link className="btn-5 btn--small" to={`/${this.props.auth.business.slug}/upload/list/${record.id}`}>{locale.get('products_list')}</Link>
                                    }
                                    {
                                        record.status_id === 1 &&
                                        <button className="btn-4 btn--small" onClick={() => this.props.restart(record)}>{locale.get('complete')}</button>
                                    }
                                </th>
                            </tr>
                        ))
                    }
                    {
                        this.state.data.length === 0 &&
                        <tr>
                            <td colSpan={4}>
                                <Loader completed={!this.state.loading}>
                                    <div className="alert-warning">
                                        { locale.get('no_lists_uploaded') }
                                    </div>
                                </Loader>
                            </td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>
        )
    }

    componentDidMount() {
        const formData = new FormData();
        axios.post(Config.api(`products/bulk-upload/listing/${this.props.businessId}`), formData, {
            withCredentials: Config.withCredentials()
        }).then((response) => {
            this.setState({
                data:response.data.results,
                loading:false
            })
        }).catch((error) => {
            if (error.response.status === 401) {

            } else {
                if (error.response && error.response.data && error.response.data.message) {
                    NotificationManager.error(error.response.data.message);
                }
            }
        });
    }
}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {

    return {
        auth: state.auth,
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(Listing);
